import React from "react";
import "./App.scss";
import Routing from "./Routes";

function App() {
  return <Routing />;
}

export default App;
